import {Form, Formik} from 'formik'
import {Fragment, useEffect, useState} from 'react'
import * as Yup from 'yup'

import Logo from '../../../_metronic/assets/everyvisit-logo.svg'

import StartedForm from '../components/Form'
import PaymentInfo from '../components/Payment'

import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import getCities from '../services/getCities'
import getCountries from '../services/getCountries'
import getRegionsByCity from '../services/getRegionsByCity'
import submitForm from '../services/submitForm'

const limit = 25
const emailLimit = 100

export default function GetStarted() {
  const intl = useIntl()
  const router = useNavigate()
  const [paymentModal, setPaymentModal] = useState(false)
  const [values, setValues] = useState<any>({RequestedPackage: 'Starter'})
  const [loading, setLoading] = useState(false)

  const [list, setList] = useState<{countries: any[]; cities: any[]; regions: any[]}>({
    countries: [],
    cities: [],
    regions: [],
  })

  const requireTranslate = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
  const long25Translate = intl.formatMessage(
    {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
    {length: 25}
  )
  const long50Translate = intl.formatMessage(
    {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
    {length: 50}
  )

  const long100Translate = intl.formatMessage(
    {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
    {length: 100}
  )

  const longMaxTranslate = intl.formatMessage(
    {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
    {length: 4}
  )
  const successTranslate = intl.formatMessage({id: 'AUTH.BECOME_MEMBER.SUCCESS'})
  const errorTranslate = intl.formatMessage({id: 'AUTH.BECOME_MEMBER.ERROR'})

  useEffect(() => {
    const availablePackages = ['Basic', 'Growth', 'Essential']
    const urlQuery = new URLSearchParams(window.location.search)
    const selectedPackage = urlQuery.get('package')

    if (!selectedPackage || !availablePackages.includes(selectedPackage)) {
      window.location.href = '/become-a-merchant/pricing'
    } else {
      setValues({...values, RequestedPackage: selectedPackage})
    }

    getCountries().then((countries) => {
      getCities(countries[0].id).then((cities) => {
        setList({...list, countries, cities})
      })
    })
  }, [])

  const changeCountry = (id: string) => {
    getCities(id).then((res) => {
      setList({...list, cities: res, regions: []})
    })
  }

  const changeCity = (id: string) => {
    getRegionsByCity(id).then((res) => {
      setList({...list, regions: res})
    })
  }

  const onSubmit = async (payment: any) => {
    const data = {...values, payment}

    const response = await submitForm(data)

    if (response.status) {
      toast.success(successTranslate, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      setTimeout(() => {
        router('/sign-in')
      }, 1000)
    } else {
      toast.error(errorTranslate, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
    }
  }

  const validSchema = Yup.object().shape({
    merchantId: Yup.string().notRequired(),
    terminalId: Yup.string().notRequired(),
    storeId: Yup.string().notRequired(),
    businessName: Yup.string().required(requireTranslate).max(limit, long25Translate),
    merchantTradeName: Yup.string().required(requireTranslate).max(limit, long25Translate),
    businessAddressLine: Yup.string().required(requireTranslate),
    taxID: Yup.string().required(requireTranslate).max(limit, long25Translate),
    telephoneNumber: Yup.string().required(requireTranslate).max(limit, long25Translate),
    email: Yup.string()
      .email('Invalid email')
      .required(requireTranslate)
      .max(emailLimit, long100Translate),
    countryId: Yup.string().required(requireTranslate).notOneOf(['0'], requireTranslate),
    cityId: Yup.string().required(requireTranslate).notOneOf(['0'], requireTranslate),
    regionId: Yup.string().required(requireTranslate).notOneOf(['0'], requireTranslate),
    zipCode: Yup.string().required(requireTranslate).max(limit, long25Translate),
    mcc: Yup.string().required(requireTranslate),
    contactGender: Yup.string().required(requireTranslate).max(limit, long25Translate),
    contactFirstName: Yup.string().required(requireTranslate).max(limit, long25Translate),
    contactMiddleName: Yup.string().max(limit, long25Translate),
    contactLastName: Yup.string().required(requireTranslate).max(limit, long25Translate),
    contactCountryPhoneCode: Yup.string().required(requireTranslate).max(4, longMaxTranslate),
    contactMobilePhone: Yup.string().required(requireTranslate).max(limit, long25Translate),
    contactEmail: Yup.string()
      .email('Invalid email')
      .required(requireTranslate)
      .max(emailLimit, long100Translate),
    workingOpenHour: Yup.string().required(requireTranslate),
    workingCloseHour: Yup.string().required(requireTranslate),
  })

  return (
    <Fragment>
      {false ? (
        <></>
      ) : (
        <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
          <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
            <div className='flex-column-fluid'>
              <div id='' className=''>
                <div className='card'>
                  <div
                    className='container-fluid d-flex align-items-stretch justify-content-between pt-8'
                    id='kt_app_header_container'
                  >
                    <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                      <div
                        className='btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px ms-n2 me-2 d-flex d-lg-none'
                        id='kt_app_sidebar_mobile_toggle'
                      >
                        <i className='ki-outline ki-abstract-14 fs-1'></i>
                      </div>

                      <a href='/sign-in'>
                        <img alt='Logo' src={Logo} className='h-30px' />
                      </a>
                    </div>

                    <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                      <div
                        className='d-flex align-items-stretch'
                        id='kt_app_header_menu_wrapper'
                      ></div>

                      <div className='app-navbar flex-shrink-0'>
                        <a
                          href='/sign-in'
                          className='btn btn-sm btn-flex btn-primary align-self-center ms-5 ms-lg-11 px-3'
                        >
                          <i className='bi bi-box-arrow-right fs-3 me-3'></i>
                          {intl.formatMessage({id: 'AUTH.GENERAL.SIGNIN_BUTTON'})}
                        </a>
                      </div>
                    </div>
                  </div>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      merchantId: '',
                      terminalId: '',
                      storeId: '',
                      businessName: '',
                      merchantTradeName: '',
                      businessAddressLine: '',
                      taxID: '',
                      telephoneNumber: '',
                      email: '',
                      countryId: '',
                      cityId: '',
                      regionId: '',
                      zipCode: '',
                      mcc: '',
                      contactGender: '',
                      contactFirstName: '',
                      contactMiddleName: '',
                      contactLastName: '',
                      contactCountryPhoneCode: '',
                      contactMobilePhone: '',
                      contactEmail: '',
                      workingOpenHour: '09:30',
                      workingCloseHour: '21:30',
                    }}
                    validationSchema={validSchema}
                    onSubmit={(form) => {
                      setPaymentModal(true)
                      setValues({...values, ...form})
                    }}
                  >
                    {({errors, touched}) => (
                      <Form>
                        <div className='d-flex justify-content-start align-items-start mt-10 gap-10'>
                          <StartedForm
                            errors={errors}
                            touched={touched}
                            list={list}
                            changeCountry={changeCountry}
                            changeCity={changeCity}
                          />
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}
